import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhySection from './components/WhySection';
import CategoryGrid from './components/CategoryGrid';
import GuidesSection from './components/GuidesSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import JsonLd from '@/components/base/JsonLd';
import { organizationSchema, homeWebPageSchema, faqPageSchema } from '@/mocks/schema';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={organizationSchema} />
      <JsonLd data={homeWebPageSchema} />
      <JsonLd data={faqPageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <WhySection />
        <CategoryGrid />
        <GuidesSection />
        <ArticlesSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}